import { render, staticRenderFns } from "./NationalTrademarkOwnerForm.vue?vue&type=template&id=48b105cd&"
import script from "./NationalTrademarkOwnerForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkOwnerForm.vue?vue&type=style&index=0&id=48b105cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports